/**
Fixes the screen height by adjusting the height of the root element when there is the impersonating div.
*/
export const fixScreenHeight = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const impersonating = document.getElementsByClassName('impersonating');

    if (impersonating.length) {
      const root = document.getElementById('root');
      if (root) {
        root.style.setProperty('height', 'calc(100% - 34px)');
      }
    }
  });
};
